var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWebappBlueCalendar = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 13,
  height: 13,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#webapp_blue_calendar_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.217 2.239A27.15 27.15 0 0 1 6.5 2.2c.29 0 .736.01 1.277.037v-.954a.643.643 0 1 1 1.285 0v1.04c.202.018.41.037.62.058a2.768 2.768 0 0 1 2.49 2.521c.086 1.022.113 1.953.113 2.378 0 .425-.027 1.355-.113 2.376a2.768 2.768 0 0 1-2.49 2.521c-1.363.14-2.594.18-3.182.18-.59 0-1.82-.04-3.182-.18a2.768 2.768 0 0 1-2.49-2.52A31.222 31.222 0 0 1 .714 7.28c0-.425.027-1.356.114-2.378a2.768 2.768 0 0 1 2.49-2.52c.208-.022.413-.041.613-.058v-1.04a.643.643 0 0 1 1.286 0v.954ZM3.5 5.29a.536.536 0 1 0 0 1.071h.428a.536.536 0 0 0 0-1.071H3.5Zm-.536 3.107c0-.296.24-.536.536-.536h.428a.536.536 0 1 1 0 1.072H3.5a.536.536 0 0 1-.536-.536Zm3.321-3.107a.536.536 0 1 0 0 1.071h.429a.536.536 0 0 0 0-1.071h-.429Zm2.25.536c0-.296.24-.536.536-.536H9.5a.536.536 0 1 1 0 1.071H9.07a.536.536 0 0 1-.536-.535Zm-2.25 2.035a.536.536 0 1 0 0 1.072h.429a.536.536 0 0 0 0-1.072h-.429Z",
  fill: "#2563EB"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "webapp_blue_calendar_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(.5 .5)",
  d: "M0 0h12v12H0z"
})))));
export default SvgWebappBlueCalendar;